{
  "id": "campaign-020",
  "name": "Beat the Storm",
  "seed": "campaign:20",
  "generatorVersion": 3,
  "level": 20,
  "biome": "backyard",
  "startDir": "N",
  "mowerRule": {
    "kind": "exclude",
    "mowers": ["fairway"]
  },
  "rows": [
    "........",
    "........",
    "........",
    "........",
    "........",
    ".*......",
    "*.....h.",
    ".....T..",
    ".B......",
    ".....#..",
    "........",
    ".....h..",
    "........",
    "........",
    "..B.....",
    "........",
    "........",
    "g.*.....",
    ".g......",
    "........",
    "....T...",
    "*.......",
    "........",
    "........",
    "....h...",
    "........",
    "........",
    ".....g..",
    "........",
    "........",
    "........",
    "....#...",
    "...*....",
    ".......#",
    "........",
    "......h.",
    "....B...",
    "...*...h",
    "........",
    ".....B..",
    "....g...",
    "........",
    "......*.",
    "....B.h.",
    "........",
    "........",
    "........",
    "....S..."
  ],
  "pickups": [
    {
      "kind": "coin",
      "x": 3,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 25
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 43
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 38
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 44
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 35
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 37
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 36
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 16
    },
    {
      "kind": "gas",
      "x": 0,
      "y": 21
    }
  ],
  "critters": [],
  "storm": {
    "delayTiles": 6,
    "pace": 7,
    "target": 0.7
  },
  "par": {
    "reel": 7980,
    "push": 6916,
    "selfPropelled": 6384,
    "tractor": 3240,
    "zeroTurn": 4522
  }
}
